<!--
  Default (and server-rendered) state is the primary BritEat landing page. When the active
  domain resolves to a business or an HQ (browser-side detection), we swap to the matching
  implementation. Those two implementations live behind @defer so they load on demand and
  do not weigh down the primary homepage bundle. The default branch renders BriteatHome
  synchronously on both server and client, so hydration matches with no divergence.
-->
@if (business) {
  @defer (on immediate) {
    <brt-business-home />
  }
} @else if (hq) {
  @defer (on immediate) {
    <brt-briteat-hq-home />
  }
} @else {
  <brt-briteat-home />
}
